import React from 'react';

const FileItem = ({ file, onDownload }) => {
  return (
    <div className="file-item">
      <div className="file-left">
        <img src={file.icon} alt={file.name.includes('.pdf') ? 'PDF' : 'Excel'} />
        <div className="file-info">
          <div className="file-name-wrapper">
            <span className="file-name">{file.name}</span>
          </div>
          <span className="file-size">{file.size}</span>
        </div>
      </div>
      <div className="download-icon" onClick={onDownload}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path d="M5 20h14v-2H5v2zm7-18v12l4.5-4.5 1.42 1.42L12 18l-5.5-5.5 1.42-1.42L11 14V2h2z" />
        </svg>
      </div>
    </div>
  );
};

export default FileItem;